import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import PageLoader from "../Common/PageLoader/PageLoader";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import WebService from "../../Services/WebService";
import { storeClientId, storeMeDetails, storeMenuList, storeSelectedOutlet } from "../../Redux/action";
import { toast } from "react-toastify";
import { GetListCommonCall } from "../../POS/APIServices/POS_API_Services";
import { saveFcmToken } from "../../firebase";


const SuperAdminRedirect = () => {
    const params = useParams();
    const [showLoader, setShowLoader] = useState(true);
    let dispatch = useDispatch();
    let navigate = useNavigate();
    useEffect(() => {
        getAuthToken(params.userId!);
    }, [params.userId]);

    const getAuthToken = (userId: string) => {
        WebService.postAPI({
            action: 'restaurant-admin-auth/auto-login/' + userId,
            body: {},
        }).then((res: any) => {
            sessionStorage.setItem('access_token', res.accessToken);
            getOutletList(res);
        }).catch((error: any) => {
            setShowLoader(false);
        });
    };
    const getOutletList = (data: any) => {
        WebService.getAPI({
            action: "outlet/my-outlet-list/" + data.staff_id + '/' + data.client_id,
            body: null,
            btnId: 'login-button',
            isShowError: true
        }).then((res: any) => {
            if (res.list.length > 0) {
                // if (res.list.length === 1 && res.list[0].has_active_subscription) {
                //     localStorage.setItem('outlet_id', res.list[0]?.id);
                //     dispatch(storeSelectedOutlet([res.list[0]]));
                //     meCall();
                // } else {
                navigate('/select-outlet', { state: { outletList: res.list } });
                // }
            }
        }).catch((err: any) => {
            toast.error(err.response.data.message);
            setShowLoader(false);
            navigate('/login');
        }).finally(() => {
        });
    }
    const meCall = () => {
        WebService.getAPI({
            action: 'staffs/me',
            body: null,
            isShowError: true
        }).then((res: any) => {
            setShowLoader(false);
            localStorage.setItem('client_id', res.data.client_id);
            dispatch(storeClientId(res.data.client_id));
            dispatch(storeMeDetails(res.data))
            getMenus();
        }).catch((error: any) => {
            toast.error(error.response.data.message);
            setShowLoader(false);
            navigate('/login');
        });
    }
    const getMenus = () => {
        GetListCommonCall("staffs/my-menus", {}, 'login-button')
            .then((res: any) => {
                const currentFcmToken = localStorage.getItem('fcm_token');
                if (currentFcmToken) {
                    saveFcmToken(currentFcmToken);
                }
                if (res.data.length > 0 && res.data.find((item: any) => item.is_enabled && item.subMenus.length > 0)) {
                    dispatch(storeMenuList(res.data))
                    if (res.data.find((item: any) => item.is_enabled && item.code === 'POS')) {
                        let url = res.data.find((item: any) => item.code === 'POS').subMenus[0].url;
                        navigate('/pos' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'INVENTORY')) {
                        let url = res.data.find((item: any) => item.code === 'INVENTORY').subMenus[0].url;
                        navigate('/inventory' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'STAFFING')) {
                        let url = res.data.find((item: any) => item.code === 'STAFFING').subMenus[0].url;
                        navigate('/staffing' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'CRM')) {
                        let url = res.data.find((item: any) => item.code === 'CRM').subMenus[0].url;
                        navigate('/crm' + url);
                    } else if (res.data.find((item: any) => item.is_enabled && item.code === 'RESTAURANT_ADMIN')) {
                        let url = res.data.find((item: any) => item.code === 'RESTAURANT_ADMIN').subMenus[0].url;
                        navigate('/restaurant-admin' + url);
                    } else {
                        let url = res.data.find((item: any) => item.is_enabled && item.code === 'FINANCE').subMenus[0].url;
                        navigate('/finance' + url);
                    }
                } else {
                    toast.error("No menu permissions assigned for outlet");
                }
            }).catch(() => { });
    }
    return (
        <>
            <Container fluid className="p-0 m-0">
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <h2 className="text-muted me-2">Redirecting</h2>
                    {showLoader &&
                        <PageLoader />
                    }
                </div>
            </Container>
        </>
    )
};

export default SuperAdminRedirect;
